import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../lib/analytics-base';

@Injectable()
export class CalendarAnalytics extends AnalyticsBase {
  public readonly namespace = 'Calendar';
  public readonly requireViewContext = true;

  public trackOpenSettings(context: 'calendar_filter_dropdown' | 'adjust_calendar_dropdown') {
    this.track('OpenSettings', { context });
  }

  public otherCalendarClick() {
    this.track('OtherCalendarClick');
  }
}
